import HelpTooltip from '@App/components/HelpTooltip/HelpTooltip';

import './unactivated-mobility-field.styl';

function UnactivatedMobilityField({ field, onClick, selected }) {
  const visibleChildren = field.children ? field.children.filter(child => child.fieldType !== 'supplement') : undefined;

  return (
    <li className={`unactivated-mobility-field${selected ? ' unactivated-mobility-field--selected' : ''}`} onClick={onClick}>
      <div className="unactivated-mobility-field__name">
        {field.displayName}
        {field.helpText && (
          <HelpTooltip id={field.name} helpText={field.helpText} />
        )}
      </div>
      {visibleChildren && (
        <ul>
          {visibleChildren.map((child) => {
            return <UnactivatedMobilityField key={child.name} field={child} />;
          })}
        </ul>
      )}
    </li>
  );
}

export default UnactivatedMobilityField;